import styled from 'styled-components'
import Link from '../../utils/Link'
import NewsFeedInfo from './StyledNewsFeedInfo'
import NewsFeedCommerceArticleSign from './StyledNewsFeedCommerceArticleSign'

export default styled(Link)`
  color: #333;
  display: flex;
  height: 100%;
  display: -ms-flexbox;
  -ms-flex-align: stretch;
  -ms-flex-direction: row;  
  &:hover ${NewsFeedInfo}, &:hover ${NewsFeedCommerceArticleSign} {
    color: #333;
  }
`
